/* eslint-disable react/prop-types */
import ComposedViewFourCompFournt from "./composed-view-four";
import { useState } from "react";
import { useHistory } from "react-router-dom";
function ComposedViewFour({ title, content, image, button, hyperLinks }) {
  const history = useHistory();
  const [imageHeight, setImageHeight] = useState(0);

  const handleImgLoad = ({ target: img }) => {
    const { offsetHeight } = img;
    setImageHeight(offsetHeight);
  };

  const handleClick = (link) => {
    history.push(link);
  };

  return (
    <ComposedViewFourCompFournt
      title={title}
      content={content}
      image={image}
      button={button}
      imageHeight={imageHeight}
      hyperLinks={hyperLinks}
      onImgLoad={handleImgLoad}
      onClick={handleClick}
    />
  );
}

export default ComposedViewFour;
